module.exports = __webpack_public_path__ + "assets/img/icon_user1.6eedc68e.png";